/* eslint-disable max-classes-per-file */
export interface RequestDetailExperienceInterface {
  ticketId?: number;
  countrySlug?: string;
  citySlug?: string;
  slug?: string;
}

export interface RequestEventDetailExperienceInterface {
  categorySlug?: string;
  subCategorySlug?: string;
  sportTeamSlug?: string;
  eventId?: string;
}
export interface ExperienceGalleryDataInterface {
  photos: string[];
  starRating: number;
  numReviews: number;
  isFavourite: boolean;
  id: number;
  locationExp: string;
  nameExp: string;
  description: string;
  sportTeamNameEn: string;
  subCategoryNameEn: string;
}

export interface ExperienceReviewDataInterface {
  rating: number;
  text_rating_1: string;
  text_rating_2: string;
  text_rating_3: string;
  text_rating_4: string;
  text_rating_5: string;
  review_rating_count: ReviewRatingCountInterface;
  review_rating_count_percent: ReviewRatingCountPercentInterface;
  commentList: ExperienceReviewCommentListInterface[];
}
export interface ExperienceReviewCommentListInterface {
  id: number;
  lang: string;
  location_id: number;
  published_date: string;
  rating: number;
  helpful_votes: string;
  rating_image_url: string;
  url: string;
  trip_type: string;
  travel_date: string;
  text: string;
  user: {
    username: string;
    user_location: {
      name: string;
      id: number;
    };
  };
  title: string;
  is_machine_translated: boolean;
  new_rating_img: string;
  text_travel_date: string;
}
export enum ExperienceHighlightType {
  TIME_DURATION = "timeduration",
  AVAILABLE_LANGUAGE = "availablelanguage",
  VEHICLE = "vehicle",
  PRICE_INCLUDES = "priceincludes",
}
export interface ExperienceHighlightsInterface {
  icon: string;
  title: string;
  body: string;
  highlightType: ExperienceHighlightType;
}
export interface ExperienceBlogInterface {
  image: {
    url: string;
    title: string;
  }[];
  description: string;
}
export interface ExperiencePreparationInterface {
  title: string;
  description: string[];
}
export interface ExperienceConditionInterface {
  titlePrepare: string;
  bodyPrepare: string[];
}
export interface ExperiencePriceConditionInterface {
  title: string;
  description: string[];
}
export interface ExperienceLocationInterface {
  lat: number;
  long: number;
}
export interface ExperienceSponsorInterface {
  logo: string;
  title: string;
  description: string;
}
export interface ExperienceExperienceInterface {
  photo_path: string[];
  detail: string;
}
export interface ExperienceBannerInterface {
  background: string;
  bannerImage: string;
  textTitleBanner1: string;
  textTitleBanner2: string;
  textDescriptBanner1: string;
  textDescriptBanner2: string;
  textDescriptBanner3: string;
}

export interface ExperienceAirlineInterface {
  logoAirline: string;
  textTitleLogo: string;
  textDescriptLogo: string;
}
export interface ExperienceExclusiveContainerQuotaInterface {
  icon: string;
  message: string;
  location: string;
  date: string;
  rating: number;
  review: number;
}
export interface ExperienceExclusiveContainerBannerImageInterface {
  background: string;
  people: string;
  shape: string;
  shapeMobile: string;
}
export interface ExperienceExclusiveContainerBannerInterface {
  title: string;
  description: string;
  route?: string;
  image: ExperienceExclusiveContainerBannerImageInterface;
  color: string;
}
export interface ExperienceExclusiveContainerInterface {
  quota: ExperienceExclusiveContainerQuotaInterface;
  exclusiveBanner: ExperienceExclusiveContainerBannerInterface;
  baseColor: string[];
  slug: string;
  citySlug: string;
  countrySlug: string;
}

export interface ExperienceButtonBannerInterface {
  name: string;
  slug: string;
  title: string;
  icon: string;
  klubName: string;
}

export interface ExperienceCardInfluencerInterface {
  imgInflu: string;
  nameInflu: string;
  detailInflu: string;
}

export interface ExperiencePrepareInterface {
  titlePrepare: string;
  bodyPrepare: string[];
}

export interface ExperienceMapInterface {
  address: string;
  latitude: number;
  longitude: number;
  areaName: string;
  cityName: string;
  countryName: string;
}

class ExperienceCategoryInterface {
  name: string;

  slug: string;

  constructor(data: any) {
    this.name = data.name || "";
    this.slug = data.slug || "";
  }
}
export interface ExperienceSEOContentInterface {
  about: {
    title: string;
    description: string;
  };
  goodToKnow: {
    title: string;
    description: string;
  };
}

export interface ExperienceKlubCategoryInterface {
  name: string;
  slug: string;
  title: string;
  icon: string;
  colors: {
    icon: string;
  };
}
export interface ExperienceDetailInterface {
  status: boolean;
  message: string;
  data: ExperienceDataInterface;
}
export interface ExperienceDataInterface {
  id: number;
  name: string;
  description: string;
  hoursOfOperation: string;
  tel: string;
  address: string;
  areaName: string;
  areaSlug: string;
  citySlug: string;
  countrySlug: string;
  cityName: string;
  countryName: string;
  categoryName: string;
  subCategoryName: string;
  subCategoryNameEn: string;
  sportTeamName: string;
  sportTeamNameEn: string;
  categorySlug: string;
  subCategorySlug: string;
  sportTeamSlug: string;
  thingsToKnow: string[];
  warrantyContent: string[];
  tier: string;
  timeDuration: string;
  transportation: string;
  isFavourite: boolean;
  bestSeller: boolean;
  photos: string[];
  location: ExperienceLocationInterface;
  sponsor: ExperienceSponsorInterface;
  availableLauguage: string[];
  ticketInclude: string[];
  rating: number;
  numReview: number;
  reviews: ExperienceReviewDataInterface;
  experience: ExperienceExperienceInterface[];
  preparation: ExperiencePreparationInterface[];
  priceCondition: ExperiencePriceConditionInterface[];
  slug: string;
  isExclusive: boolean;
  isSoldOut: boolean;
  type: string;
  ticketType: string;
  banner: ExperienceBannerInterface;
  airline: ExperienceAirlineInterface;
  exclusiveContainer: ExperienceExclusiveContainerInterface;
  buttonBanner: ExperienceButtonBannerInterface;
  cardInfluencer: ExperienceCardInfluencerInterface;
  gallery: ExperienceGalleryDataInterface;
  experienceblog: ExperienceBlogInterface[];
  prepare: ExperiencePrepareInterface[];
  condition: ExperienceConditionInterface[];
  map: ExperienceMapInterface;
  highlights: ExperienceHighlightsInterface[];
  category: ExperienceCategoryInterface[];
  seoContent: ExperienceSEOContentInterface;
  klubCategory: ExperienceKlubCategoryInterface;
}

export interface ReviewRatingCountInterface {
  1: string;
  2: string;
  3: string;
  4: string;
  5: string;
}

export interface ReviewRatingCountPercentInterface {
  1: string | number;
  2: string | number;
  3: string | number;
  4: string | number;
  5: string | number;
}
class GetDetailExpLocationInterface {
  lat: number;

  long: number;

  constructor(val: ExperienceLocationInterface) {
    this.lat = val?.lat || 0;
    this.long = val?.long || 0;
  }
}
class GetDetailExpSponsorInterface {
  logo: string;

  title: string;

  description: string;

  constructor(val: ExperienceSponsorInterface) {
    this.logo = val?.logo || "";
    this.title = val?.title || "";
    this.description = val?.description || "";
  }
}
class GetDetailExpRatingCountInterface {
  1: string;

  2: string;

  3: string;

  4: string;

  5: string;

  constructor(val: ReviewRatingCountPercentInterface) {
    this[1] = String(val?.[1] || ""); // แปลงเป็น string
    this[2] = String(val?.[2] || "");
    this[3] = String(val?.[3] || "");
    this[4] = String(val?.[4] || "");
    this[5] = String(val?.[5] || "");
  }
}
class GetDetailExpReviewCommentListUserLocationInterface {
  name: string;

  id: number;

  constructor(
    val: ExperienceReviewCommentListInterface["user"]["user_location"],
  ) {
    this.name = val?.name || "";
    this.id = val?.id || 0;
  }
}
class GetDetailExpReviewCommentListUserInterface {
  username: string;

  user_location: {
    name: string;

    id: number;
  };

  constructor(val: ExperienceReviewCommentListInterface["user"]) {
    this.username = val?.username || "";
    this.user_location = new GetDetailExpReviewCommentListUserLocationInterface(
      val?.user_location,
    );
  }
}
class GetDetailExpReviewCommentListInterface {
  id: number;

  lang: string;

  location_id: number;

  published_date: string;

  rating: number;

  helpful_votes: string;

  rating_image_url: string;

  url: string;

  trip_type: string;

  travel_date: string;

  text: string;

  user: {
    username: string;

    user_location: {
      name: string;

      id: number;
    };
  };

  title: string;

  is_machine_translated: boolean;

  new_rating_img: string;

  text_travel_date: string;

  constructor(val: ExperienceReviewCommentListInterface) {
    this.id = val?.id || 0;
    this.lang = val?.lang || "";
    this.location_id = val?.location_id || 0;
    this.published_date = val?.published_date || "";
    this.rating = val?.rating || 0;
    this.helpful_votes = val?.helpful_votes || "";
    this.rating_image_url = val?.rating_image_url || "";
    this.url = val?.url || "";
    this.trip_type = val?.trip_type || "";
    this.travel_date = val?.travel_date || "";
    this.text = val?.text || "";
    this.user = new GetDetailExpReviewCommentListUserInterface(val?.user);
    this.title = val?.title || "";
    this.is_machine_translated = val?.is_machine_translated || false;
    this.new_rating_img = val?.new_rating_img || "";
    this.text_travel_date = val?.text_travel_date || "";
  }
}
class GetDetailExpReviewDataInterface {
  rating: number;

  text_rating_1: string;

  text_rating_2: string;

  text_rating_3: string;

  text_rating_4: string;

  text_rating_5: string;

  review_rating_count: ReviewRatingCountInterface;

  review_rating_count_percent: ReviewRatingCountPercentInterface;

  commentList: ExperienceReviewCommentListInterface[];

  constructor(val: ExperienceReviewDataInterface) {
    this.rating = val?.rating || 0;
    this.text_rating_1 = val?.text_rating_1 || "";
    this.text_rating_2 = val?.text_rating_2 || "";
    this.text_rating_3 = val?.text_rating_3 || "";
    this.text_rating_4 = val?.text_rating_4 || "";
    this.text_rating_5 = val?.text_rating_5 || "";
    this.review_rating_count = new GetDetailExpRatingCountInterface(
      val?.review_rating_count,
    );
    this.review_rating_count_percent = new GetDetailExpRatingCountInterface(
      val?.review_rating_count_percent,
    );
    this.commentList = (val?.commentList || []).map(
      (item) => new GetDetailExpReviewCommentListInterface(item),
    );
  }
}
class GetDetailExpExpInterface {
  photo_path: string[];

  detail: string;

  constructor(val: ExperienceExperienceInterface) {
    this.photo_path = val?.photo_path || [];
    this.detail = val?.detail || "";
  }
}
class GetDetailExpPreparationInterface {
  title: string;

  description: string[];

  constructor(val: ExperiencePreparationInterface) {
    this.title = val?.title || "";
    this.description = val?.description || [];
  }
}
class GetDetailExpPriceConditionInterface {
  title: string;

  description: string[];

  constructor(val: ExperiencePriceConditionInterface) {
    this.title = val?.title || "";
    this.description = val?.description || [];
  }
}
class GetDetailExpBannerInterface {
  background: string;

  bannerImage: string;

  textTitleBanner1: string;

  textTitleBanner2: string;

  textDescriptBanner1: string;

  textDescriptBanner2: string;

  textDescriptBanner3: string;

  constructor(val: ExperienceBannerInterface) {
    this.background = val?.background || "";
    this.bannerImage = val?.bannerImage || "";
    this.textTitleBanner1 = val?.textTitleBanner1 || "";
    this.textTitleBanner2 = val?.textTitleBanner2 || "";
    this.textDescriptBanner1 = val?.textDescriptBanner1 || "";
    this.textDescriptBanner2 = val?.textDescriptBanner2 || "";
    this.textDescriptBanner3 = val?.textDescriptBanner3 || "";
  }
}
class GetDetailExpAirlineInterface {
  logoAirline: string;

  textTitleLogo: string;

  textDescriptLogo: string;

  constructor(val: ExperienceAirlineInterface) {
    this.logoAirline = val?.logoAirline || "";
    this.textTitleLogo = val?.textTitleLogo || "";
    this.textDescriptLogo = val?.textDescriptLogo || "";
  }
}
class GetDetailExpExclusiveContainerQuotaInterface {
  icon: string;

  message: string;

  location: string;

  date: string;

  rating: number;

  review: number;

  constructor(val: ExperienceExclusiveContainerQuotaInterface) {
    this.icon = val?.icon || "";
    this.message = val?.message || "";
    this.location = val?.location || "";
    this.date = val?.date || "";
    this.rating = val?.rating || 0;
    this.review = val?.review || 0;
  }
}
class GetDetailExpExclusiveContainerExclusiveBannerImageInterface {
  background: string;

  people: string;

  shape: string;

  shapeMobile: string;

  constructor(val: ExperienceExclusiveContainerBannerImageInterface) {
    this.background = val?.background || "";
    this.people = val?.people || "";
    this.shape = val?.shape || "";
    this.shapeMobile = val?.shapeMobile || "";
  }
}
class GetDetailExpExclusiveContainerExclusiveBannerInterface {
  title: string;

  description: string;

  route: string;

  image: ExperienceExclusiveContainerBannerImageInterface;

  color: string;

  constructor(val: ExperienceExclusiveContainerBannerInterface) {
    this.title = val?.title || "";
    this.description = val?.description || "";
    this.route = val?.route || "";
    this.image =
      new GetDetailExpExclusiveContainerExclusiveBannerImageInterface(
        val?.image,
      );
    this.color = val?.color || "";
  }
}
class GetDetailExpExclusiveContainerInterface {
  quota: GetDetailExpExclusiveContainerQuotaInterface;

  exclusiveBanner: ExperienceExclusiveContainerBannerInterface;

  baseColor: string[];

  slug: string;

  citySlug: string;

  countrySlug: string;

  constructor(val: ExperienceExclusiveContainerInterface) {
    this.quota = new GetDetailExpExclusiveContainerQuotaInterface(val?.quota);
    this.exclusiveBanner =
      new GetDetailExpExclusiveContainerExclusiveBannerInterface(
        val?.exclusiveBanner,
      );
    this.baseColor = val?.baseColor || [];
    this.slug = val?.slug || "";
    this.citySlug = val?.citySlug || "";
    this.countrySlug = val?.countrySlug || "";
  }
}
class GetDetailExpButtonBannerInterface {
  name: string;

  slug: string;

  title: string;

  icon: string;

  klubName: string;

  constructor(val: ExperienceButtonBannerInterface) {
    this.name = val?.name || "";
    this.slug = val?.slug || "";
    this.title = val?.title || "";
    this.icon = val?.icon || "";
    this.klubName = val?.klubName || "";
  }
}
class GetDetailExpCardInfluencerInterface {
  imgInflu: string;

  nameInflu: string;

  detailInflu: string;

  constructor(val: ExperienceCardInfluencerInterface) {
    this.imgInflu = val?.imgInflu || "";
    this.nameInflu = val?.nameInflu || "";
    this.detailInflu = val?.detailInflu || "";
  }
}
class GetDetailExpGalleryDataInterface {
  photos: string[];

  starRating: number;

  numReviews: number;

  isFavourite: boolean;

  id: number;

  locationExp: string;

  nameExp: string;

  description: string;

  sportTeamNameEn: string;

  subCategoryNameEn: string;

  constructor(val: ExperienceGalleryDataInterface) {
    this.photos = val?.photos || [];
    this.starRating = val?.starRating || 0;
    this.numReviews = val?.numReviews || 0;
    this.isFavourite = val?.isFavourite || false;
    this.id = val?.id || 0;
    this.locationExp = val?.locationExp || "";
    this.nameExp = val?.nameExp || "";
    this.description = val?.description || "";
    this.sportTeamNameEn = val?.sportTeamNameEn || "";
    this.subCategoryNameEn = val?.subCategoryNameEn || "";
  }
}
class GetDetailExpExperienceBlogInterface {
  image: {
    url: string;

    title: string;
  }[];

  description: string;

  constructor(val: ExperienceBlogInterface) {
    this.image = val?.image || [];
    this.description = val?.description || "";
  }
}
class GetDetailExpPrepareInterface {
  titlePrepare: string;

  bodyPrepare: string[];

  constructor(val: ExperiencePrepareInterface) {
    this.titlePrepare = val?.titlePrepare || "";
    this.bodyPrepare = val?.bodyPrepare || [];
  }
}
class GetDetailExpConditionInterface {
  titlePrepare: string;

  bodyPrepare: string[];

  constructor(val: ExperienceConditionInterface) {
    this.titlePrepare = val?.titlePrepare || "";
    this.bodyPrepare = val?.bodyPrepare || [];
  }
}
class GetDetailExpMapInterface {
  address: string;

  latitude: number;

  longitude: number;

  areaName: string;

  cityName: string;

  countryName: string;

  constructor(val: ExperienceMapInterface) {
    this.address = val?.address || "";
    this.latitude = val?.latitude || 0;
    this.longitude = val?.longitude || 0;
    this.areaName = val?.areaName || "";
    this.cityName = val?.cityName || "";
    this.countryName = val?.countryName || "";
  }
}
class GetDetailExpHighlightsInterface {
  icon: string;

  title: string;

  body: string;

  highlightType: ExperienceHighlightType;

  constructor(val: ExperienceHighlightsInterface) {
    this.icon = val?.icon || "";
    this.title = val?.title || "";
    this.body = val?.body || "";
    this.highlightType =
      val?.highlightType || ExperienceHighlightType.TIME_DURATION;
  }
}
class GetDetailExpSeoContendDataInterface {
  title: string;

  description: string;

  constructor(val: ExperienceSEOContentInterface["about"]) {
    this.title = val?.title || "";
    this.description = val?.description || "";
  }
}
class GetDetailExpSeoContentInterface {
  about: GetDetailExpSeoContendDataInterface;

  goodToKnow: GetDetailExpSeoContendDataInterface;

  constructor(val: ExperienceSEOContentInterface) {
    this.about = new GetDetailExpSeoContendDataInterface(val?.about);
    this.goodToKnow = new GetDetailExpSeoContendDataInterface(val?.goodToKnow);
  }
}
class GetDetailExpKlubCategoryInterface {
  name: string;

  slug: string;

  title: string;

  icon: string;

  colors: {
    icon: string;
  };

  constructor(val: ExperienceKlubCategoryInterface) {
    this.name = val?.name || "";
    this.slug = val?.slug || "";
    this.title = val?.title || "";
    this.icon = val?.icon || "";
    this.colors = {
      icon: val?.colors.icon || "",
    };
  }
}
class GetDetailExpDataInterface {
  id: number;

  name: string;

  description: string;

  hoursOfOperation: string;

  tel: string;

  address: string;

  areaName: string;

  areaSlug: string;

  citySlug: string;

  countrySlug: string;

  cityName: string;

  countryName: string;

  categoryName: string;

  subCategoryName: string;

  subCategoryNameEn: string;

  sportTeamName: string;

  sportTeamNameEn: string;

  categorySlug: string;

  subCategorySlug: string;

  sportTeamSlug: string;

  thingsToKnow: string[];

  warrantyContent: string[];

  tier: string;

  timeDuration: string;

  transportation: string;

  isFavourite: boolean;

  isSoldOut: boolean;

  bestSeller: boolean;

  photos: string[];

  location: ExperienceLocationInterface;

  sponsor: ExperienceSponsorInterface;

  availableLauguage: string[];

  ticketInclude: string[];

  rating: number;

  numReview: number;

  reviews: ExperienceReviewDataInterface;

  experience: ExperienceExperienceInterface[];

  preparation: ExperiencePreparationInterface[];

  priceCondition: ExperiencePriceConditionInterface[];

  slug: string;

  isExclusive: boolean;

  type: string;

  ticketType: string;

  banner: ExperienceBannerInterface;

  airline: ExperienceAirlineInterface;

  exclusiveContainer: ExperienceExclusiveContainerInterface;

  buttonBanner: ExperienceButtonBannerInterface;

  cardInfluencer: ExperienceCardInfluencerInterface;

  gallery: ExperienceGalleryDataInterface;

  experienceblog: ExperienceBlogInterface[];

  prepare: ExperiencePrepareInterface[];

  condition: ExperienceConditionInterface[];

  map: ExperienceMapInterface;

  highlights: ExperienceHighlightsInterface[];

  category: ExperienceCategoryInterface[];

  seoContent: ExperienceSEOContentInterface;

  klubCategory: ExperienceKlubCategoryInterface;

  constructor(val: ExperienceDataInterface) {
    this.id = val?.id || 0;
    this.name = val?.name || "";
    this.description = val?.description || "";
    this.hoursOfOperation = val?.hoursOfOperation || "";
    this.tel = val?.tel || "";
    this.address = val?.address || "";
    this.areaName = val?.areaName || "";
    this.cityName = val?.cityName || "";
    this.countryName = val?.countryName || "";
    this.areaSlug = val?.areaSlug || "";
    this.citySlug = val?.citySlug || "";
    this.countrySlug = val?.countrySlug || "";
    this.categoryName = val?.categoryName || "";
    this.subCategoryName = val?.subCategoryName || "";
    this.subCategoryNameEn = val?.subCategoryNameEn || "";
    this.sportTeamName = val?.sportTeamName || "";
    this.sportTeamNameEn = val?.sportTeamNameEn || "";
    this.categorySlug = val?.categorySlug || "";
    this.subCategorySlug = val?.subCategorySlug || "";
    this.sportTeamSlug = val?.sportTeamSlug || "";
    this.thingsToKnow = val?.thingsToKnow || [];
    this.warrantyContent = val?.warrantyContent || [];
    this.tier = val?.tier || "";
    this.timeDuration = val?.timeDuration || "";
    this.transportation = val?.transportation || "";
    this.isFavourite = val?.isFavourite || false;
    this.bestSeller = val?.bestSeller || false;
    this.isSoldOut = val?.isSoldOut || false;
    this.photos = val?.photos || [];
    this.location = new GetDetailExpLocationInterface(val?.location);
    this.sponsor = new GetDetailExpSponsorInterface(val?.sponsor);
    this.availableLauguage = val?.availableLauguage || [];
    this.ticketInclude = val?.ticketInclude || [];
    this.rating = val?.rating || 0;
    this.numReview = val?.numReview || 0;
    this.reviews = new GetDetailExpReviewDataInterface(val?.reviews);
    this.experience = (val?.experience || []).map(
      (item) => new GetDetailExpExpInterface(item),
    );
    this.preparation = (val?.preparation || []).map(
      (item) => new GetDetailExpPreparationInterface(item),
    );
    this.priceCondition = (val?.priceCondition || []).map(
      (item) => new GetDetailExpPriceConditionInterface(item),
    );
    this.slug = val?.slug || "";
    this.isExclusive = val?.isExclusive || false;
    this.type = val?.type || "";
    this.ticketType = val?.ticketType || "";
    this.banner = new GetDetailExpBannerInterface(val?.banner);
    this.airline = new GetDetailExpAirlineInterface(val?.airline);
    this.exclusiveContainer = new GetDetailExpExclusiveContainerInterface(
      val?.exclusiveContainer,
    );
    this.buttonBanner = new GetDetailExpButtonBannerInterface(
      val?.buttonBanner,
    );
    this.cardInfluencer = new GetDetailExpCardInfluencerInterface(
      val?.cardInfluencer,
    );
    this.gallery = new GetDetailExpGalleryDataInterface(val?.gallery);
    this.experienceblog = (val?.experienceblog || []).map(
      (item) => new GetDetailExpExperienceBlogInterface(item),
    );
    this.prepare = (val?.prepare || []).map(
      (item) => new GetDetailExpPrepareInterface(item),
    );
    this.condition = (val?.condition || []).map(
      (item) => new GetDetailExpConditionInterface(item),
    );

    this.map = new GetDetailExpMapInterface(val?.map);

    this.highlights = (val?.highlights || []).map(
      (item) => new GetDetailExpHighlightsInterface(item),
    );
    this.category = (val?.category || []).map(
      (item) => new ExperienceCategoryInterface(item),
    );
    this.seoContent = new GetDetailExpSeoContentInterface(val?.seoContent);
    this.klubCategory = new GetDetailExpKlubCategoryInterface(
      val?.klubCategory,
    );
  }
}

export class ResponseExperienceDataInterface {
  status: boolean;

  message: string;

  data: ExperienceDataInterface;

  constructor(val: any) {
    this.status = val?.status || false;
    this.message = val?.message || "";
    this.data = new GetDetailExpDataInterface(val?.data);
  }
}
